import { Admin } from '@apis/index'
import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import theme from '@utils/theme'
import { Form, Formik } from 'formik'
import React, { Fragment, useState } from 'react'
import { toast } from 'react-toastify'

const ChangePassword = () => {
  const [initialValues, setInitialValues] = useState({
    current: '',
    new: '',
    confirm: '',
  })
  const handleChanePassword = async (values) => {
    try {
      if (values.new != values.confirm) {
        toast.error("Passwords don't match")
      }
      const payload = {
        currentPassword: values.current,
        newPassword: values.new,
      }
      await Admin.changePassword({ data: JSON.stringify(payload) })
    } catch (error) {}
  }
  return (
    <Fragment>
      <Column>
        <p
          style={{
            color: theme.colors.primary,
            textAlign: 'center',
            fontWeight: '400',
            fontSize: '18px',
          }}
        >
          Change Password
        </p>
        <Formik
          initialValues={initialValues}
          onSubmit={handleChanePassword}
          enableReinitialize
        >
          <Form>
            <Column>
              <Fields.Password
                name="current"
                label="Current Password"
                placeholder="Enter new Password"
              />
              <Fields.Password
                name="new"
                label="New Password"
                placeholder="Enter New Password"
              />
              <Fields.Password
                name="confirm"
                label="Confirm Password"
                placeholder=" Confirm Password"
              />
              <Button
                type="submit"
                title="change password"
                width={100}
                height={46}
              />
            </Column>
          </Form>
        </Formik>
      </Column>
    </Fragment>
  )
}

export default ChangePassword
